import React from 'react'

const AnunciantesAdminRoutes = [
    {
        path: '/parceiros',
        exact: true,
        component: React.lazy(() => import('./cadastros/lista/Table')),
    },
    {
        path: '/parceiros/novo',
        exact: true,
        component: React.lazy(() => import('./cadastros/form/Form')),
    
    },
    {
        path: '/parceiros/editar',
        exact: true,
        component: React.lazy(() => import('./cadastros/form/Form')),
    },
    {
        path: '/parceiros/visualizar',
        exact: true,
        component: React.lazy(() => import('./cadastros/lista/Detalhes')),
    },
    {
        path: '/anunciantes/resgatar/:rc',
        exact: true,
        component: React.lazy(() => import('../../../pages/Anunciantes/ResgateCupomPage')),
    },
   
]

export default AnunciantesAdminRoutes
